export const endpoints = {
  SOCIAL_NETWORK_URLS: '/v1/company-config/social-network-url'
};
